import { path, pathOr } from 'ramda'
import { createSelector } from 'reselect'

import { BOARD_PATH } from './base'

const DASHBOARD_PATH = [...BOARD_PATH, 'dashboard']
const DASHBOARD_USER_PATH = [...DASHBOARD_PATH, 'user']
const DASHBOARD_CHART_PATH = [...DASHBOARD_PATH, 'chartData']
const DASHBOARD_DATE_RANGE_PATH = [...DASHBOARD_PATH, 'dateRange']

const TOPIC_COUNTS_PATH = [...BOARD_PATH, '@board/topic-counts']
const USER_TOPIC_COUNTS_PATH = [...BOARD_PATH, '@board/topics-by-user']

export const dashboardUserSelector = path(DASHBOARD_USER_PATH)
export const dashboardChartDataSelector = path(DASHBOARD_CHART_PATH)
export const dashboardDateRangeSelector = path(DASHBOARD_DATE_RANGE_PATH)

export const topicCountsSelector = pathOr({}, TOPIC_COUNTS_PATH)
const userTopicCountsSelector = pathOr({}, USER_TOPIC_COUNTS_PATH)

// for topics analytics, grab topic usage per user ID as an array
export const userTopicCountsArraySelector = createSelector(
  userTopicCountsSelector,
  userTopicCounts =>
    Object.entries(userTopicCounts).reduce(
      (acc, [userId, topics]) => [...acc, { userId, topics }],
      []
    )
)
